import $ from 'jquery';
import _ from 'lodash';
import ScrollMagic from 'scrollmagic';
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');
// import TweenMax, { Power2 } from 'gsap';
import { TweenMax, TimelineMax, Power2 } from 'gsap';

var Vars = {
	controller: null,
};

Vars.controller = new ScrollMagic.Controller();

$(document).ready(function() {
	fxHighlight();
	
	setTimeout(() => {
		fxArrows();
		fxZigueZague();
		fxEstampas();
	}, 1000);
});

var win = $(window);

/**
 * Texto + Imagem grande que
 * ficam abaixo do menu principal (topo)
 */
function fxHighlight() {
  let elHighlight = $('#main-highlight');
  let elHighlightImage = elHighlight.find('.h-product-image');
	let elHighlightInfo = elHighlight.find('.h-product-info');
	
	let winWidth = win.width();

  if(elHighlightImage.length) {
    TweenMax.set([elHighlightImage, elHighlightInfo], {
      position: 'relative',
      top: '0px',
    })

    let tweenu = TweenMax.to(elHighlightImage, 1, {
      top: winWidth >= 678 ? '100px' : '0px',
    });

    let tweeny = TweenMax.to(elHighlightInfo, 1, {
      top: winWidth >= 678 ? '-50px' : '-5px',
    });

    new ScrollMagic.Scene({
      offset: 0,
      duration: window.innerHeight,
    }).setTween(tweenu)
    // .addIndicators()
    .addTo(Vars.controller);

    new ScrollMagic.Scene({
      offset: 0,
      duration: window.innerHeight,
    }).setTween(tweeny)
    // .addIndicators()
    .addTo(Vars.controller);
  }
}

/**
 * Setinhas dos sliders
 */
function fxArrows() {
  let winHeight = win.height();
  let arrowDelay = winHeight / 5;
  
  $('.slider-arrow.left').each(function() {
    let elArrow = $(this);

    TweenMax.set(elArrow, {
      opacity: 0,
      marginLeft: '-100px',
    });

    let tweenu = TweenMax.to(elArrow, .5, {
      marginLeft: '0px',
      opacity: 1,
      ease: Power2.easeInOut,
    });

    // console.log('elArrow:: ', elArrow.offset());

    new ScrollMagic.Scene({
      offset: elArrow.offset().top - winHeight + arrowDelay,
      duration: 0
    }).setTween(tweenu)
    // .addIndicators()
    .addTo(Vars.controller);
  });

  $('.slider-arrow.right').each(function() {
    let elArrow = $(this);

    TweenMax.set(elArrow, {
      opacity: 0,
      marginRight: '-100px',
    });

    let tweenu = TweenMax.to(elArrow, .5, {
      marginRight: '0px',
      opacity: 1,
      ease: Power2.easeInOut,
    });

    // console.log('elArrow:: ', elArrow.offset());

    new ScrollMagic.Scene({
      offset: elArrow.offset().top - winHeight + arrowDelay,
      duration: 0
    }).setTween(tweenu)
    // .addIndicators()
    .addTo(Vars.controller);
  });
}

/**
 * Container de textos de cada slide do zigue zague
 */
function fxZigueZague() {
	let winHeight = win.height();
	let animDelay = winHeight / 1.8;

	let zzController = null;
	
	// console.log('elItem ', elItem[0].style);
	
	let createZZScene = () => {
		var isLeft = $('.zigue-zague').hasClass('invertido');
		$('.zigue-zague-item').each(function() {
			let elItem = $(this);
			let elContent = elItem.find('.zigue-zague-content');
			
			let tweenu = null;

			if(isLeft) {
				TweenMax.set(elContent, {
					opacity: 0,
					marginLeft: '-100px',
				});

				tweenu = TweenMax.to(elContent, .5, {
					marginLeft: '0px',
					opacity: 1,
					ease: Power2.easeOut,
				});
			} else {
				TweenMax.set(elContent, {
					opacity: 0,
					marginRight: '-100px',
				});

				tweenu = TweenMax.to(elContent, .5, {
					marginRight: '0px',
					opacity: 1,
					ease: Power2.easeOut,
				});
			}

			let offsetTop = elItem.offset().top - winHeight + animDelay;

			// new ScrollMagic.Scene({
			// 	offset: offsetTop,
			// 	duration: 0
			// }).setTween(tweenu)
			// // .addIndicators()
			// .addTo(zzController);

			
			///////////////////////////////////////////////////////
			// Corte lateral
			let elImg = elItem.find('.zigue-zague-img');
			let corte = elItem.find('.corte-lateral');
			let corteHeight = elContent.height() + parseInt(elContent.css('padding-top')) + parseInt(elContent.css('padding-bottom'));
			let corteLeft = isLeft ? 'auto' : elImg.width() - 6;
			let corteRight = isLeft ? elImg.width() - 6 : 'auto';
			corte.css({
				'left': corteLeft,
				'right': corteRight,
				'marginTop': (corteHeight / -2) - 4,
				'width': '15px',
				'height': corteHeight,
			});
			let tweenCorte = TweenMax.to(corte, .3, {
				transform: 'scaleY(1)'
			});
			///////////////////////////////////////////////////////

			var timeline = new TimelineMax();
			timeline.add(tweenCorte).add(tweenu);

			new ScrollMagic.Scene({
				offset: offsetTop,
				duration: 0
			}).setTween(timeline)
			// .addIndicators()
			.addTo(zzController);


			isLeft = !isLeft;

			// mScene = createZZScene().addTo(Vars.controller);
			// console.log('mScene: ', mScene);
			
			// let renewScene = () => {
			// 	if(win.width() < 800) {
			// 		if(mScene) {
			// 			mScene.destroy();
						
			// 			if(isLeft) {
			// 				TweenMax.set(elContent, {
			// 					opacity: 1,
			// 					margin: 'auto',
			// 				});
			// 			} else {
			// 				TweenMax.set(elContent, {
			// 					opacity: 1,
			// 					margin: 'auto',
			// 				});
			// 			}
			// 		}
			// 	} else {
			// 		mScene = createZZScene().addTo(Vars.controller);
			// 	}
			// };

			// renewScene();

			// win.on('resize', _.debounce(renewScene, 200));

			// win.on('resize', () => {
			// 	console.log('resize!');
			// 	if(win.width() < 800) {
			// 		mScene.destroy();
			// 	} else {
			// 		mScene = createZZScene().addTo(Vars.controller);
			// 	}
			// }, 200);
		});
	};

	let resizedController = () => {
		if(win.width() < 800) {
			if(zzController) {
				zzController.destroy();
			}
			TweenMax.set($('.zigue-zague-content'), {
				opacity: 1,
				marginLeft: 'auto',
				marginRight: 'auto',
			});
		} else {
			if(!zzController) {
				zzController = new ScrollMagic.Controller();
				createZZScene();
			}
		}
	};

	resizedController();
	win.on('resize', resizedController);
}

/**
 * Tooltip: Clique 2x para dar zoom
 */
function fxEstampas() {
	let winHeight = win.height();
	let winDelay = winHeight / 5;

	$('.section-estampas').each(function() {
		let elSection = $(this);
		let elTooltips = elSection.find('.zoomtwo-item-info');
		elTooltips.show();
		TweenMax.set(elTooltips, {
      opacity: 0,
		});

		let tweenu = new TimelineMax();
		
		tweenu.to(elTooltips, .5, {
      opacity: 1,
      ease: Power2.easeInOut,
    }).to(elTooltips, .5, {
			opacity: 0,
			ease: Power2.easeInOut,
		}, '+=1.5');

    let tscene = new ScrollMagic.Scene({
			// offset: elTooltips.offset().top - winHeight,
			offset: elSection.offset().top + winDelay,
      duration: 0
    }).setTween(tweenu)
    // .addIndicators()
		.addTo(Vars.controller);
		
		tscene.on('enter', ev => {
			if(!window.IS_TAP_ENABLED) {
				elTooltips.hide();
			} else {
				elTooltips.show();
				tscene.offset(elSection.offset().top + winDelay);
			}
		});
	});

	// $('.zoomtwo-item-info').each(function() {
	// 	let elTooltip = $(this);
	// 	elTooltip.show();
		
	// 	TweenMax.set(elTooltip, {
  //     opacity: 0,
	// 	});

	// 	let tweenu = new TimelineMax();
		
	// 	tweenu.to(elTooltip, .5, {
  //     opacity: 1,
  //     ease: Power2.easeInOut,
  //   }).to(elTooltip, .5, {
	// 		opacity: 0,
	// 		ease: Power2.easeInOut,
	// 	}, '+=1');

  //   new ScrollMagic.Scene({
	// 		// offset: elTooltip.offset().top - winHeight,
	// 		triggerElement: elTooltip,
  //     duration: 0
  //   }).setTween(tweenu)
  //   .addIndicators()
  //   .addTo(Vars.controller);
	// });
}
